import React from 'react'
import cx from 'classnames'

import { CategoryCard } from 'components/shared/CategoryCard/CategoryCard'
import { Form } from 'components/shared/Form/Form'
import { getIsCompetencySelected } from 'components/shared/CompetenciesFormFields/helpers'

import { COMPETENCIES_FIELD } from './model'

import styles from './CompetenciesFormFields.module.scss'

export const CompetenciesFormFields = ({
  activeCategory,
  className,
  isCompetenciesDisabled = false,
  categories,
  control,
  formState,
  order,
  onClick,
}: {
  activeCategory
  className?: string
  isCompetenciesDisabled?: boolean
  categories
  control
  formState
  order
  onClick
}) => {
  const byCategory: Record<
    string,
    { description: string; index: number; label: string; name: string }[]
  > = categories.reduce(
    (acc, { category, description, label, name }, index) => ({
      ...acc,
      [category]: [
        ...(acc[category] ?? []),
        { description, index, label, name },
      ],
    }),
    {},
  )
  const sorted = Object.entries(byCategory).sort(
    ([current], [next]) => order.indexOf(current) - order.indexOf(next),
  )

  return (
    <div className={cx(styles.fields, className)}>
      {sorted.map(([category, competencies]) => (
        <CategoryCard key={category} {...{ activeCategory, category, onClick }}>
          {competencies.map(({ index, label, name }) => {
            const isSelected = getIsCompetencySelected(name, formState)

            return (
              <Form.Field
                error={formState.errors[name]?.message}
                field="checkbox"
                key={`${COMPETENCIES_FIELD}[${index}].${name}`}
                name={`${COMPETENCIES_FIELD}[${index}].${name}`}
                isDisabled={isCompetenciesDisabled && !isSelected}
                {...{ control, label }}
              />
            )
          })}
        </CategoryCard>
      ))}
    </div>
  )
}
